<template>
  <div class="card-902" data-slot="default">
    <div class="card-902-image-wrapper d-block">
      <m-img :src="image" :alt="alt" class=" card-902-image p-0 m-0"/>
    </div>
    <div class="card-902-content-wrapper d-block">
      <slot>lorem</slot>
    </div>
  </div>
</template>

<script>
import {CardProps} from "./CardProps";
import mImg from '../Tags/Img'
import mA from '../Tags/A'

export default {
  name: "Card902",
  components: {mA, mImg},
  props: {
    ...CardProps
  }
}
</script>

<style scoped>
.card-902-image {
  width: 100%;
  height: 160px;
  object-fit: contain;
}
</style>